import { constants } from "@newsela/angelou";

const { colors } = constants;

export const instructionsContainerCss = {
  margin: "24px 0 16px 0",
};

export const instructionsFieldCss = {
  background: colors.ui.white[700],
  borderRadius: "4px",
  padding: "24px 16px",
};
